import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home'
import forgot from '@/views/forgot'
import signup from '@/views/signup'
import athletes from '@/views/athletes'
import athleteProfile from '@/views/athleteProfile'
import events from '@/views/events'
import eventProfile from '@/views/eventProfile'
import highSchools from '@/views/highSchools'
import highSchoolProfile from '@/views/highSchoolProfile'
import clubs from '@/views/clubs'
import clubProfile from '@/views/clubProfile'
import profile from '@/views/profile'
import prospectDays from '@/views/prospectDays'
import verifyEmail from '@/views/verifyEmail'
import VueRouter from 'vue-router'

Vue.use(Router)

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: forgot
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup
    },
    {
      path: '/verifyEmail',
      name: 'verifyEmail',
      component: verifyEmail
    },
    {
      path: '/athletes',
      name: 'athletes',
      component: athletes,
      meta: { requiresAuth: true }
    },
    {
      path: '/athletes/:id',
      name: 'athleteProfile',
      component: athleteProfile,
      meta: { requiresAuth: true }
    },
    {
      path: '/events',
      name: 'events',
      component: events,
      meta: { requiresAuth: true }
    },
    {
      path: '/events/:id',
      name: 'eventProfile',
      component: eventProfile,
      meta: { requiresAuth: true }
    },
    {
      path: '/highSchools',
      name: 'highSchools',
      component: highSchools,
      meta: { requiresAuth: true }
    },
    {
      path: '/highSchools/:id',
      name: 'highSchoolProfile',
      component: highSchoolProfile,
      meta: { requiresAuth: true }
    },
    {
      path: '/clubs',
      name: 'clubs',
      component: clubs,
      meta: { requiresAuth: true }
    },
    {
      path: '/clubs/:id',
      name: 'clubProfile',
      component: clubProfile,
      meta: { requiresAuth: true }
    },
    {
      path: '/profile',
      name: 'profile',
      component: profile,
      meta: { requiresAuth: true }
    },
    {
      path: '/prospectdays',
      name: 'prospectDays',
      component: prospectDays,
      meta: { requiresAuth: true }
    },
  ]
})
